import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { IconLabelBox } from '../../IconLabelBox';
import { OkFilledIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const OkIcon: FC<Props> = ({ style, variant }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <WbInfoTooltip
      title="Compliant"
      icon={
        <span>
          {variant === 'reduced' ? (
            <OkFilledIcon
              htmlColor={theme.palette.success.main}
              className={classes.icon}
              style={style}
            />
          ) : (
            <IconLabelBox
              label="Success"
              backgroundColor={theme.palette.success.main}
              value="OK"
            />
          )}
        </span>
      }
    />
  );
};
